import { servicePhilosophies } from '@/mocks/solutionsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ServicePhilosophy() {
  return (
    <section className="relative bg-white py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src={readdy('philosophy-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">服务理念</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                绿色 · 高效 · 无忧 · 个性化
              </h2>
              <p className="text-gray-400 text-sm mt-3 max-w-xl mx-auto">
                十余年深耕，我们始终坚持"长期主义"的健康管理理念
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {servicePhilosophies.map((item, i) => (
              <ScrollReveal key={item.title} variant="fade-up" delay={i * 100}>
                <div className="text-center p-6 md:p-8 rounded-2xl border border-brand-light/30 hover:border-brand-cream hover:shadow-md transition-all duration-300 cursor-pointer group">
                  <div className={`w-14 h-14 flex items-center justify-center mx-auto mb-5 rounded-2xl ${item.color}`}>
                    <i className={`${item.icon} ${item.iconColor} text-2xl`} />
                  </div>
                  <h3 className="text-base font-semibold text-brand-deep mb-3">{item.title}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}